import porderApi from '@/api/apiList/porderApi'
import siteConfiguration from '@/api/apiList/siteConfiguration'
import spotCheckApi from '@/api/apiList/spotCheckApi'
import Vue from 'vue'
import { Message } from 'element-ui';
import { getAreaGridName } from '@/utlis/warehouseGrid'

// 配送单列表和打印清单共用区域用途编码及完整库位编号。
function getWmsGridName(data) {
  const gridData = data && data.wms_grid ? data.wms_grid : data
  if (!gridData || !gridData.grid_number) return ''
  const areaTypeCode = gridData.wms_shelf ? gridData.wms_shelf.area_type_code : ''
  return getAreaGridName(areaTypeCode, gridData.grid_number)
}

const porderDetail = {
  state: {
    checked: false, //全选
    detail: {
      list: [],
    }, //详情
    list: [], //列表
    selectedList: [], //选中的列表
    receiver: {}, //收货地址
    importer: {}, //进口商
    status: "", //配送单状态
    boxList: [],//箱子列表
    boxDetail: {},//箱子详情
    boxIds: [],//选择的箱子id
    selectBox: [],//选中的箱子号
    boxStatus: '',//箱子状态
    logisticsList: [],//物流列表
    boxWuliuData: [],//箱子物流比例填写
    problemLogistics: [],//问题物流号
    printData: [],//打印数据
    logistics: '',//打印物流方式
    is_authorized: '',//是否授权
    isPack: false, //是否查看已装箱
    totalShouldPay_JPY: 0,//运费
    findAllBlockImporterList: [],//千速黑名单列表
    logisticsTotalVolume: [],//物流合计体积
  },
  getters: {
  },
  mutations: {
    // 处理详情数据
    setPorderDetail(state, data) {
      let num = 0
      data.list.forEach((item, index) => {
        let itemData = data.list.find(items => items.set_detail_id == item.order_detail_id) //查询是否是组套主商品
        if (itemData) {
          item.isZhu = true
          item.group = itemData.group

        }
        item.checked = false;
        item.splitNum = item.num
        item.possible_num = 0
        //计算上架可能数
        item.order_purchase.forEach(items => {
          item.possible_num += items.possible_num
        })
        // 报价时预填实际标签数
        if (data.status == 22 && data.sub_porder == false && data.p_porder == null) {
          item.porder_detail_tag.forEach((items) => {
            num += items.match_num - 0;
          });
          // data.fba_complete_num ? data.fba_complete_num :
          data.fba_complete_num = num
        }
        item.stockTotal = 0
        // 计算是否全出货
        item.wms_stock.forEach(stock => {
          stock.wms_grid_name = getWmsGridName(stock)
          if (stock.wms_grid) {
            stock.wms_grid.wms_grid_name = stock.wms_grid_name
          }
          item.stockTotal += stock.num - 0
        })
        //Amazon纳品 实际纳品数量默认等于预计纳品数量
        if (data.status == 22 && item.freight_num == item.num) {
          item.received_num = item.received_num === '' || item.received_num === null ? item.planned_num : item.received_num
        }
        item.spotDetail = []

      });
      // 配送单重新报价时候用
      data.other_price_list.forEach(item => {
        item.is_refund = '1'
      })
      state.list = data.list;
      state.detail = data;
      state.status = data.status;
      state.importer = data.importer ? data.importer : {
        address: "",
        address_roma: "",
        bank_no: "",
        company: "",
        company_roma: "",
        contacts: "",
        contacts_roma: "",
        created_at: "",
        email: "",
        id: '',
        mobile: "",
        standard_no: "",
        tax_no: "",
        tel: "",
        title: "",
        user_id: '',
        zip_code: ""
      };
      state.receiver = data.receiver ? data.receiver : {
        address: "",
        address_roma: "",
        bank_no: "",
        company: "",
        company_roma: "",
        contacts: "",
        contacts_roma: "",
        created_at: "",
        email: "",
        id: '',
        mobile: "",
        standard_no: "",
        tax_no: "",
        tel: "",
        title: "",
        user_id: '',
        zip_code: ""
      };
      state.importer.company_roma = state.importer.company_roma || "";
      state.receiver.company_roma = state.receiver.company_roma || "";
      Vue.prototype.$forceUpdate();
    },
    // 获取箱子列表
    setFreightList(state, data) {
      state.logisticsTotalVolume = []
      data.forEach((item) => {
        item.group.forEach((items) => {
          let index = state.logisticsTotalVolume.findIndex(logistics => logistics.logistics_id == items.logistics_id)
          if (index == -1) {
            state.logisticsTotalVolume.push({
              logistics_name: items.logistics_name,
              totalVolume: items.totalVolume,
              logistics_id: items.logistics_id
            })
          } else {
            state.logisticsTotalVolume[index].totalVolume += items.totalVolume
          }

          items.checked = false;
          items.charged_weight = ''
          items.list.forEach((box) => {
            box.checked = false;
          });
        });
      });
      state.boxList = data;
    },
    // 箱子ids
    setBoxIds(state, data) {
      state.boxIds = data
    },
    // 箱子号
    setBox(state, data) {
      state.selectBox = data
    },
    //箱子详情
    setBoxDetail(state, data) {
      state.boxDetail = data
    },
    //箱子状态
    setBoxStatus(state, data) {
      state.boxStatus = data
    },
    //物流方式
    setLogisticsList(state, data) {
      state.logisticsList = data
    },
    //配送单当前应该收取的总费用
    setPorderAmountCurrent(state, data) {
      state.detail.logistics_price = data.totalLogisticsFee
      state.totalShouldPay_JPY = data.totalShouldPay_JPY
      state.detail.exchange_rate = data.exchange_rate ? data.exchange_rate : state.detail.exchange_rate
      state.detail.service_fee = data.totalServiceFeeJpy
      state.detail.service_fee_list = data.service_fee_list
      // 按照物流方式插入计费重量
      state.boxList.forEach((item) => {
        item.group.forEach((items) => {
          if (data.logisticsFeePart != null) {
            data.logisticsFeePart.forEach((logisticsFee) => {
              if (items.logistics_id == logisticsFee.logistics_id) {
                items.charged_weight = logisticsFee.charged_weight
              }
            });
          }
        });
      });
      Vue.prototype.$forceUpdate();
    },
    //批量填写物流单号 
    setWuliuFillIn(state, data) {
      state.boxWuliuData = data
    },
    //问题物流号
    setProblemLogistics(state, data) {
      state.problemLogistics = data
    },
    //打印唛头数据
    setPrintData(state, data) {
      state.printData = data.printData
      state.logistics = data.logistics
      state.is_authorized = data.is_authorized
    },
    // 是否查看已装箱的
    setIsPack(state, data) {
      state.isPack = data.filterByFreightNum
    },
    // 获取千速黑名单列表
    setFindAllBlockImporter(state, data) {
      state.findAllBlockImporterList = data
    },
    //配送单详情-抽查任务
    setSpotPorderDetail(state, data) {
      for (let key in data) {
        let index = state.list.findIndex(item => item.order_detail_id == key)
        if (data[key] != false) {
          state.list[index].spotDetail = data[key]
        }
      }
      Vue.prototype.$forceUpdate();
      // console.log(state.list);

    }
  },
  actions: {
    // 详情
    porderDetail({ commit, dispatch }, data) {
      porderApi.porderDetail(data).then(res => {
        commit('setPorderDetail', res.data)
        // 获取箱子列表
        if (res.data.status >= 21) {
          dispatch('freightList', data)
        }
        // 抽查查询
        dispatch('getSpotPorderDetail', data)
        // 配送单当前应该收取的总费用
        // if (res.data.status >= 22) {
        //   dispatch('getPorderAmountCurrent', data)
        // }
      })
    },
    // 配送单装箱详情 切换状态用
    porderDetailStatus({ commit }, data) {
      porderApi.porderDetail(data).then(res => {
        commit('setPorderDetail', res.data)
        commit('setIsPack', data)
      })
    },
    //箱子列表
    freightList({ commit, dispatch, state }, data) {
      porderApi
        .freightList(data)
        .then((res) => {
          commit('setFreightList', res.data)

          // 配送单当前应该收取的总费用
          if (state.detail.status >= 22) {
            dispatch('getPorderAmountCurrent', data)
          }

        });
    },
    //箱子详情
    boxDetail({ commit }, data) {
      porderApi
        .boxDetail(data)
        .then((res) => {
          res.data.list.forEach(item => {
            item.list.forEach(items => {
              items.checked = false
              items.list.forEach(itemss => {
                itemss.cancelEncasementNum = itemss.num //取消装箱数量end移箱数量
              })
            })
          })
          commit('setBoxDetail', res.data)
        });
    },
    //物流列表
    getLogisticsList({ commit }) {
      siteConfiguration
        .logisticsList({ is_show: 1, })
        .then((res) => {
          commit('setLogisticsList', res.data)
        });
    },
    //获取千速黑名单列表
    findAllBlockImporter({ commit }) {
      porderApi
        .findAllBlockImporter({ is_show: 1, })
        .then((res) => {
          commit('setFindAllBlockImporter', res.data.obj)
        });
    },

    // 配送单当前应该收取的总费用
    getPorderAmountCurrent({ commit }, data) {
      porderApi
        .porderAmountCurrent(data)
        .then((res) => {
          commit('setPorderAmountCurrent', res.data)
        });
    },
    // 业务开始翻译(禁止客户提交)
    isYEditing({ dispatch }, data) {
      porderApi.isYEditing(data).then(res => {
        Message.success(res.msg)
        if (data.is_y_editing == 0) {
          location.reload()
        }
      })
    },
    //配送单详情-抽查任务查询
    getSpotPorderDetail({ commit }, data) {
      spotCheckApi
        .getSpotPorderDetail(data)
        .then((res) => {
          commit('setSpotPorderDetail', res.data)
        });
    },

  },
};

export default porderDetail;
